import images from 'assets/images/images'
import {useRequest} from 'hooks/useRequest'
import useTranslate from 'hooks/useTranslate'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import auth from 'utils/Auth'

const DeliveryTypeApprovalModal = ({ onApprove ,announcementModal, setAnnouncementModal }) => {
  const [modalContent, setModalContent] = useState({id:null,title:'',body:''})
  const [contentRequest, contentLoading] = useRequest()
  const {t} = useTranslate() 
  const onClose = () => {
    if (auth.getPopups()) {
      auth.updatePopups({...announcementModal.content,onShowDate:moment()})
    }else {
      auth.setPopups([{...announcementModal.content,onShowDate:moment()}])
    }
    setAnnouncementModal({open: false, content: null})
  }
  const isTeslimat = announcementModal.content?.title?.toLowerCase()?.includes('teslimat tipi')
  useEffect(() => {
   if (announcementModal.content?.id) {
    const headerOptions = {
        RestaurantId : auth?.getUserChoises()?.restaurantId,
        DeliveryType : auth?.getUserChoises()?.deliveryType,
        NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
        RegionId : auth?.getUserChoises()?.regionId,
        id:announcementModal.content.id
      }
    contentRequest(`/Popup/${announcementModal.content?.id}`, {
      method: 'GET',
      headers: headerOptions
    }).then(res => {
      setModalContent(res?.data?.result)
    })
   }
   if (!announcementModal.open) {
    setModalContent({id:null,title:'',body:''})
   }
  },[announcementModal.content?.id, announcementModal.open])
  return (
    announcementModal.open && <div className="announcement">
      {
        contentLoading && <div className="announcement-modal">
        <div className='skeleton skeleton-text'/>
        <div className='skeleton skeleton-text'/>
        <div className='skeleton skeleton-footer mx-auto'/>
      </div>
      }
    {
      modalContent?.contentType == 0 &&  <div className="announcement-container">
        {
          contentLoading && <div className='skeleton skeleton-text'/>
        }
        <img loading="lazy" className="announcement-container-close" src={images.close} onClick={onClose} alt=""/>
        <img className="announcement-container-fullImage" src={modalContent.imageLink} alt=""/>
        {/* <div className="announcement-container-bottom">
            <Checkbox name='emailPermission' />
          <span>Tekrar Gösterme</span>
        </div> */}
      </div>
    }
    {
      modalContent && modalContent?.contentType == 1 && <div className="announcement-modal">
        <div className="announcement-modal-body">
       
        <img onClick={onClose} src={images.close} className="announcement-modal-body-close" />
          {
            isTeslimat && <img className='announcement-modal-body-attention' src={images.attention} />
          }
          <div className="announcement-modal-body-title">
            {modalContent?.title}
          </div>
          <div className="announcement-modal-body-desc" style={{maxWidth:isTeslimat ? '516px' : '', textAlign: isTeslimat ? 'center' : 'left'}} dangerouslySetInnerHTML={{__html:modalContent?.body}}/>
        </div>
        <div className='d-flex align-items-center gap-3'>
          {
            onApprove ? <>
            <button className="btn-primary-outline" onClick={onClose}>{t('cancel')}</button>
            <button className="btn-primary" onClick={async()=>{
             await onApprove();
              onClose();
            }}>{t('approve')}</button>
            </>
            : <button className="btn-primary" onClick={onClose}>{t('ok')}</button>
          }
        </div>
        {/* <div className="announcement-modal-checkbox">
          <Checkbox name='emailPermission' className='mb-0' />
          <span>Tekrar Gösterme</span>
        </div> */}
      </div>
    }
</div>
  )
}

export default DeliveryTypeApprovalModal